const _ = require("lodash");
const { getUser } = require("./../../enhancers/defaultObjects");

export const entity = _.defaults({
    getUserHabFunctions: async function(user, context) {
        const userWithHabs = await this.get(user.id, {group: context.group, fieldPath: ["habilitations"]});
        return _(userWithHabs.habilitations)
            .filter(habilitation => _.get(habilitation, 'group.id') === _.get(context, 'group.id'))
            .groupBy(habilitation => habilitation.habFunction.id)
            .map(habilitations => ({habilitations, ...habilitations[0].habFunction}))
            .value();
    }
}, getUser())
